import { adminAPIService } from './index'

const route = 'trendings'

export const getTrendingTopBrandList = () => adminAPIService({
  url: `${route}/top-brands`,
  method: 'get',
})

export const getTrendingTopBrandDetail = slug => adminAPIService({
  url: `${route}/top-brands/${slug}`,
  method: 'get',
})

export const updateTrendingTopBrand = (topBrands, slug) => {
  const body = `json=${encodeURIComponent(JSON.stringify(topBrands))}`
  return adminAPIService({
    url: `${route}/top-brands/${slug}`,
    method: 'post',
    data: body,
  })
}

export const getTrendingBrandList = () => adminAPIService({
  url: `${route}/brands`,
  method: 'get',
})

export const getTrendingBrandDetail = slug => adminAPIService({
  url: `${route}/brands/${slug}`,
  method: 'get',
})

export const updateTrendingBrand = (brands, slug) => {
  const body = `json=${encodeURIComponent(JSON.stringify(brands))}`
  return adminAPIService({
    url: `${route}/brands/${slug}`,
    method: 'post',
    data: body,
  })
}

export const getTrendingSearchDetail = () => adminAPIService({
  url: `${route}/searches`,
  method: 'get',
})

export const updateTrendingSearch = (searches) => {
  const body = `json=${encodeURIComponent(JSON.stringify(searches))}`
  return adminAPIService({
    url: `${route}/searches`,
    method: 'post',
    data: body,
  })
}

export const getBannerSchedules = (page = 1, size = 50) => {
  return adminAPIService({
    url: `${route}/banner-schedules`,
    method: 'get',
    params: { page, size },
  })
}

export const getBannerScheduleDetail = (id) => {
  return adminAPIService({
    url: `${route}/banner-schedules/${id}`,
    method: 'get',
  })
}

export const addBannerSchedule = (bannerDetail) => {
  const body = `json=${encodeURIComponent(JSON.stringify(bannerDetail))}`
  return adminAPIService({
    url: `${route}/banner-schedules`,
    method: 'post',
    data: body,
  })
}
export const editBannerSchedule = (bannerDetail, id) => {
  const body = `json=${encodeURIComponent(JSON.stringify(bannerDetail))}`
  return adminAPIService({
    url: `${route}/banner-schedules/${id}`,
    method: 'post',
    data: body,
  })
}